<table class="contact-table">
  <thead>
    <tr>
      <th class="header-cell">Cargo</th>
      <th class="header-cell">Nombre</th>
      <th class="header-cell">Email</th>
      <th class="header-cell">Extensión</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="data-cell bold-text">Supervisor Vehículo Nuevo</td>
      <td class="data-cell">Laura Martín</td>
      <td class="data-cell">
        <a href="mailto:lauramartin@grupogestoriapastor.com"
          >lauramartin@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">207</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Supervisor Vehículo Usado</td>
      <td class="data-cell">Carlos Orti</td>
      <td class="data-cell">
        <a href="mailto:carlosorti@grupogestoriapastor.com"
          >carlosorti@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">205</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Supervisor Tráfico</td>
      <td class="data-cell">Pedro López</td>
      <td class="data-cell">
        <a href="mailto:pedrolopez@grupogestoriapastor.com"
          >pedrolopez@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">211</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Facturación</td>
      <td class="data-cell">Clara Jiménez</td>
      <td class="data-cell">
        <a href="mailto:clarajimenez@grupogestoriapastor.com"
          >clarajimenez@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">209</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Contabilidad</td>
      <td class="data-cell">Clara Seco</td>
      <td class="data-cell">
        <a href="mailto:claraseco@grupogestoriapastor.com"
          >claraseco@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">217</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Informática</td>
      <td class="data-cell">Víctor Valero</td>
      <td class="data-cell">
        <a href="mailto:vvalero@grupogestoriapastor.com"
          >vvalero@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell"></td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Documentación VN</td>
      <td class="data-cell"></td>
      <td class="data-cell">
        <a href="mailto:e-matriculas@grupogestoriapastor.com"
          >e-matriculas@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell"></td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Documentación VO</td>
      <td class="data-cell"></td>
      <td class="data-cell">
        <a href="mailto:transferencias@grupogestoriapastor.com"
          >transferencias@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell"></td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Plan Moves</td>
      <td class="data-cell">Jose Teruel</td>
      <td class="data-cell">
        <a href="mailto:joseteruel@grupogestoriapastor.com"
          >joseteruel@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">222</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">AEAT (IVA / Minusvalías)</td>
      <td class="data-cell">Belén Martinez</td>
      <td class="data-cell">
        <a href="mailto:belenmartinez@grupogestoriapastor.com"
          >belenmartinez@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">206</td>
    </tr>
    <tr>
      <td class="data-cell bold-text">Transportes</td>
      <td class="data-cell">Rafa Zahonero</td>
      <td class="data-cell">
        <a href="mailto:rafazahonero@grupogestoriapastor.com"
          >rafazahonero@grupogestoriapastor.com</a
        >
      </td>
      <td class="data-cell">212</td>
    </tr>
  </tbody>
</table>
